import * as React from "react";
const SvgMyOrders = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
	id: "my_orders_svg__Layer_2",
	"data-name": "Layer 2"
}, /* @__PURE__ */ React.createElement("g", {
	id: "my_orders_svg__Layer_1-2",
	"data-name": "Layer 1"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0 0h24v24H0z",
	style: { fill: "none" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M12 11v3",
	style: { fill: "#fff" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M12 4a3 3 0 0 0-3 3v1h6V7a3 3 0 0 0-3-3",
	style: { fill: "none" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M18.06 6.25h-1.14a5 5 0 0 0-9.84 0H6A2.11 2.11 0 0 0 4 8L1.51 20.22a2.11 2.11 0 0 0 2.07 2.53h16.86a2.1 2.1 0 0 0 2.07-2.51L20.13 8a2.11 2.11 0 0 0-2.07-1.75M12 4a3 3 0 0 1 2.89 2.25H9.11A3 3 0 0 1 12 4M5.94 8.25H7V9h2v-.75h6V9h2v-.75h1.15l2.42 12.5H3.44Z",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "m10.28 15.61-1.45-2.16-1.66 1.1 2.55 3.84 6.83-4.56-1.1-1.66z",
	style: { fill: "currentColor" }
}))));
export default SvgMyOrders;
